import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { LanguageSwitchComponent } from './language-switch/language-switch.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
	imports: [CommonModule, RouterModule, SharedModule, TranslateModule],
	declarations: [
		FooterComponent,
		NavbarComponent,
		SidebarComponent,
		LanguageSwitchComponent,
	],
	exports: [
		FooterComponent,
		NavbarComponent,
		SidebarComponent,
		LanguageSwitchComponent,
	],
})
export class ComponentsModule {}
